import type { User, AuthSession } from '@/types/auth';
import { apiFetch } from './client';

export function getMe(): Promise<User> {
  return apiFetch<User>('/api/auth/me');
}

export function sendOtp(phone: string): Promise<{ ok: boolean; message: string; status?: 'otp_sent' | 'pending_approval' }> {
  return apiFetch('/api/auth/whatsapp/send-otp', {
    method: 'POST',
    body: JSON.stringify({ phone }),
  });
}

export function verifyOtp(phone: string, code: string): Promise<AuthSession> {
  return apiFetch('/api/auth/whatsapp/verify-otp', {
    method: 'POST',
    body: JSON.stringify({ phone, code }),
  });
}

export function logout(): void {
  localStorage.removeItem('wa_access_token');
  window.location.href = '/login';
}
